require('./brokerInternalTransferFundsSuccess.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @utilities
const { recordLinkV2 } = require('utilities/tagging');
const { formatPercentage, formatAmount } = require('utilities/currencyHelper');
const { recordPage } = require('utilities/tagging.js')

// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const BrokerInternalTransferFundsDetails = require('components/broker/brokerInternalTransferFunds/brokerInternalTransferFundsDetails/brokerInternalTransferFundsDetails');
const BrokerInterestModal = require('../brokerInterestModal/brokerInterestModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');

// @constants
const { MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL } = require('constants/index');
const { FUNDS_PERIODIC_CONTRIBUTION } = require('constants/flagBasedFeatures');
// @constants
const {
    FIRST_STEP,
    BROKER_INTERNAL_TRANSFER_EXISTING_FUND,
    BROKER_TRANSFER_VALUES_TYPE_PARTIAL
} = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/brokerInternalTransferFunds.tracking');
const { CURRENCIES_SYMBOLS } = require('constants/currencies');

class BrokerInternalTransferFundsSuccess extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleToggleModal = this.handleToggleModal.bind(this);
    this.handleClickContributionLink = this.handleClickContributionLink.bind(this);
    this.state = {
      showInterestModal: false,
    };
  }

  generateFundDetails(fund) {
    const { immBrokerMyInvestments, immBrokerInternalTransferFunds, immFunds } = this.props;
    const fundId  = immBrokerInternalTransferFunds.getIn(['steps', 0, fund]);
    const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
    const selectedFund = funds.find(fund => fund.get('id') === fundId);

    if(selectedFund) {
        const fundDetails = immFunds.find(fund =>
            selectedFund &&
            fund.getIn(['contrato','producto']) === selectedFund.get('product') &&
            fund.getIn(['contrato','numerodecontrato']) === selectedFund.get('numerodecontrato')
        );

        if(fundDetails) {
            return fundDetails.merge({
                controlDigit: selectedFund.get('controlDigit')
            });
        }
    }
}

formatParticipationsAmount(raw) {
    const fraction = `${raw}`.split('.')[1];
    const fractionLength = fraction ? fraction.length : 0;

    return formatAmount(raw, null, fractionLength);
}

  componentDidMount() {
    const {
      immBrokerInternalTransferFunds,
    } = this.props;

    const transferType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'type']);
    const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
    const originFundCurrency = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundCurrency']);

    const amounts = {
      percentage:  formatPercentage(immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'percentage'])),
      participations: `${immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'participations'])} participations`,
      amount: `${formatAmount(immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'amount']))}${CURRENCIES_SYMBOLS[originFundCurrency]}`,
    };

    const originFund = this.generateFundDetails('originFund');
    const destinationFund = this.generateFundDetails('destinationFund');
    const participations = this.formatParticipationsAmount(
        originFund.get('participaciones')
    );
    const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);

    const from = originFund.get('descripcion', '');
    let to = '';

    if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
        to = destinationFund.get('descripcion', '');
    } else {
        to = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundName']);
    }

    const amount =
      transferType === BROKER_TRANSFER_VALUES_TYPE_PARTIAL ? amounts[partialType] : participations;

    const customData = {
      data: `from: ${from}, to: ${to}`,
      amount: amount,
    };

    recordPage(customData);
    recordLinkV2(catalogue[analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_SUCCESS]());
  }

  handleClick() {
    const url = `/myprofile/broker/`; // @hardcoded
    this.props.history.push(url);
  }

  handleToggleModal = () => {
    this.setState({ showInterestModal: !this.state.showInterestModal });
  };

  handleClickContributionLink = () => {
    const { immInvestmentFunds } = this.props;
    const fundSecId = immInvestmentFunds.getIn([
      'steps',
      FIRST_STEP,
      'investmentFunds',
      'customInstitutionSecurityId',
    ]);

    const contributionsLink = `/myprofile/broker/fundsPeriodicContribution/${fundSecId}/0/skip`;
    this.props.history.push(contributionsLink);
  };

  render() {
    const {
      immFunds,
      immBrokerInternalTransferFunds,
      immBrokerMyInvestments,
      immAccounts,
      immFlagBasedFeatures
    } = this.props;
    const ffContribution = immFlagBasedFeatures.get(FUNDS_PERIODIC_CONTRIBUTION);
    const orderNumber = immBrokerInternalTransferFunds.getIn(['destinationFund', 'orderNumber']);
    const mainButtonLabel = formatText('broker-etfBuySuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText('stocksContract-reviewOrders');
    const subtitle = `${formatText(
      'brokerRightsCashExchange-brokerRightsCashExchange_successSubtitle'
    )}${orderNumber}`;
    const isin = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']);
    const originHasContribution = immBrokerInternalTransferFunds.getIn([
      'steps',
      FIRST_STEP,
      'originHasContribution',
    ]);
    const destinationHasContribution = immBrokerInternalTransferFunds.getIn([
      'steps',
      FIRST_STEP,
      'destinationHasContribution',
    ]);
    const bothFundsNotContribution = !originHasContribution && !destinationHasContribution;
    const isContributionSuccess = immBrokerInternalTransferFunds.get('newContributionSuccess');
    const isSkipedContributionStep = immBrokerInternalTransferFunds.get('skipContributionStep');
    const newContributionAmount = immBrokerInternalTransferFunds.getIn(['steps', 1, 'amount']);

    const linkToContribution = (
      <OKButton
        modifier="link-emphasize"
        onClick={this.handleClickContributionLink}
      >
        {formatText('brokerInternalTransferFund-linkToContribution')}
      </OKButton>
    );

    const linkToInterest = (
      <OKButton modifier="link-emphasize" onClick={this.handleToggleModal}>
        {formatText('brokerInternalTransferFund-linkToInterest')}
      </OKButton>
    );

    const disclaimerNewContribution = (
      <FormattedTextWithComponents
        className={'broker-internal-transfer-funds-success__disclaimerNewContribution'}
        value={'brokerInternalTransferFund-disclaimerNewContribution'}
        injectedComponents={[linkToContribution, linkToInterest]}
      />
    );

    const contributionFailDisclaimer = !isContributionSuccess &&
      ffContribution &&
      originHasContribution &&
      newContributionAmount > 0 &&
      !isSkipedContributionStep && (
        <OKMessage
          type="warning"
          title={formatText('brokerInternalTransferDetails-disclaimerContribErrorTitle')}
        >
          <FormattedText value="brokerInternalTransferDetails-disclaimerContribError" />
        </OKMessage>
      );

    const transferType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'type']);
    const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
    const originFundCurrency = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundCurrency']);
    const originFund = this.generateFundDetails('originFund');

    const participations = this.formatParticipationsAmount(
        originFund.get('participaciones')
    );

    const amounts = {
      percentage:  formatPercentage(immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'percentage'])),
      participations: `${immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'participations'])} participations`,
      amount: `${formatAmount(immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'amount']))}${CURRENCIES_SYMBOLS[originFundCurrency]}`,
    };

    const amount =
      transferType === BROKER_TRANSFER_VALUES_TYPE_PARTIAL ? amounts[partialType] : participations;

    return (
      <WizardSuccess
        successMessage={formatText('brokerInternalTransferFund-success')}
        successMessageChildren={subtitle}
        customClassName="broker-internal-transfer-funds-success"
        mainButton={{ label: mainButtonLabel, url: '/myprofile/broker', modifier: 'secondary' }}
        secondaryButton={{
          label: secondaryButtonLabel,
          url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL,
        }}
        tealium={catalogue[analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_SUCCESS]({
          productName: isin,
          amount: amount
        })}
        isSecondVersion
      >
        <div className="broker-internal-transfer-funds-success__details">
          <BrokerInternalTransferFundsDetails
            immFunds={immFunds}
            immBrokerInternalTransferFunds={immBrokerInternalTransferFunds}
            immBrokerMyInvestments={immBrokerMyInvestments}
            isSuccess={true}
            immAccounts={immAccounts}
          />
        </div>
        {bothFundsNotContribution && ffContribution ? disclaimerNewContribution : null}
        <BrokerInterestModal
          isOpen={this.state.showInterestModal}
          onCloseCallback={this.handleToggleModal}
        />
        {contributionFailDisclaimer}
      </WizardSuccess>
    );
  }
}

BrokerInternalTransferFundsSuccess.propTypes = {
  history: PropTypes.object.isRequired,
  immBrokerMyInvestments: PropTypes.object.isRequired,
  immBrokerInternalTransferFunds: PropTypes.object.isRequired,
  immFunds: PropTypes.object.isRequired,
  immAccounts: PropTypes.object.isRequired,
  immFlagBasedFeatures: PropTypes.object,
};

module.exports = withRouter(BrokerInternalTransferFundsSuccess);
